import { TrendingUp, ClipboardList, FileText, Users, DollarSign, Clock, HardDrive } from "lucide-react";
import { Kpi, fmtDate } from "./HubShared";

/**
 * Top KPI strip for the AI Visibility Command Hub.
 * Split from AIVisibilityHub.jsx to keep the parent under 400 lines.
 */
export default function HubKpis({ kpis }) {
  const k = kpis || {};
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-10">
      <Kpi label="Audit leads"   value={k.audit_leads_total}  sub={`${k.audit_leads_7d} this week`} icon={TrendingUp}     testId="kpi-audit-leads" />
      <Kpi label="Intakes total" value={k.intakes_total}      sub={`${k.intakes_pending} pending`} icon={ClipboardList} testId="kpi-intakes" />
      <Kpi label="Reports built" value={k.reports_generated}  sub={`${k.intakes_submitted} submitted`} icon={FileText}   testId="kpi-reports" />
      <Kpi label="Subscribers"   value={k.active_subscribers} sub="AI Visibility add-ons"           icon={Users}         testId="kpi-subs" />
      <Kpi label="MRR"           value={`$${(k.monthly_revenue || 0).toLocaleString()}`} sub="from add-ons" icon={DollarSign} testId="kpi-mrr" accent="emerald" />
      <Kpi label="Next re-audit" value={fmtDate(k.next_reaudit_due)} sub="quarterly cadence" icon={Clock}                testId="kpi-reaudit" />
      <Kpi
        label="Storage"
        value={k.storage_bytes ? `${(k.storage_bytes / 1024 / 1024).toFixed(1)} MB` : "0 MB"}
        sub={`${k.storage_files || 0} files across all purposes`}
        icon={HardDrive}
        testId="kpi-storage"
      />
    </div>
  );
}
